import { render, staticRenderFns } from "./AnalyzerRoot.vue?vue&type=template&id=a0245c48&scoped=true"
import script from "./AnalyzerRoot.vue?vue&type=script&lang=js"
export * from "./AnalyzerRoot.vue?vue&type=script&lang=js"
import style0 from "./AnalyzerRoot.vue?vue&type=style&index=0&id=a0245c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0245c48",
  null
  
)

export default component.exports